import { render, staticRenderFns } from "./lrCreateuser.vue?vue&type=template&id=58321828"
import script from "./lrCreateuser.vue?vue&type=script&lang=js"
export * from "./lrCreateuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports